module.exports = __webpack_public_path__ + "img/Group118.e3a9e5d1.png";